import { type ReactElement, type SVGProps } from 'react';

export const FlagIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 3V21H4V16H21L15.1175 10.5293L21 5H4V3H3ZM4 6V15H18.4469L13.652 10.5353L18.4505 6H4Z"
        fill="currentColor"
      />
    </svg>
  );
};
